import httpUtil from "@/utils/httpUtil";

export const selectCodePrintList = params => httpUtil.get("/storePrint", params);

export const addCodePrint = params => httpUtil.post("/storePrint", params);
// export const delCodePrint = params => httpUtil.post("/storePrint/del", params);


export const selectAllPrintList = params => httpUtil.get("/storePrint/noPage", params);
export const del = params => httpUtil.post("/storePrint/del", params);

